import Button from "../../Button";
import React, { useContext } from "react";
import constants from "../../../constants";
import AlertContext from "../../../context/AlertContext";
import RightArrowSvgIcon from "../../../Svg/RightArrowSvgIcon";
import systemCheck from "../../../assets/images/systemCheck.png";
import InstructionPageWizardHooks from "../../../Hooks/InstructionPage/InstructionPageWizardHooks";

export default function SystemCheck() {
  const Alert = useContext(AlertContext);

  const InstructionPageWizardHks = InstructionPageWizardHooks();

  return (
    <div className="systemCheckMainContainer">
      Provide Webcam Access
      <p className="systemCheckDesc">
        <span>
          To keep the test fair and secure, we need access to your webcam.
        </span>
        <span>
          Please allow camera permissions when prompted, your face should be
          clearly visible at all times.
        </span>
      </p>
      <div className="systemCheckImgDiv">
        <img src={systemCheck} alt="systemCheck" className="systemCheckImg" />
      </div>
      <div className="systemCheckBtn">
        <Button
          size="sm"
          onClick={InstructionPageWizardHks.handleNext}
          icon={
            Alert.testData.testmode === constants.MODE.TEST_MODE && {
              type: "trailing",
              icon: <RightArrowSvgIcon type={2} />,
            }
          }
          hierarchy={{
            type: "primary",
            buttonText:
              Alert.testData.testmode === constants.MODE.TEST_MODE
                ? "Proceed"
                : "Connect Phone",
          }}
        />
      </div>
    </div>
  );
}
